module.exports = __webpack_public_path__ + "img/결과공유.4d3888f2.png";